import React from 'react';
import Grid from '../Grid';

import styles from './privacy.module.scss';
import BackButton from '../BackButton';
import Footer from '../Footer';

interface Props {
  plain: boolean;
  privacyContent: any;
}

const Privacy: React.FC<Props> = ({
  plain,
  privacyContent,
}: Props) => {
  return (
    <div className={styles.page}>
      { !plain && <BackButton action={null} /> }
      <Grid rows={privacyContent.gridContent.rows} />
      { !plain && <Footer /> }
    </div>
  )
}

export default Privacy;